export default __webpack_public_path__ + "media/images/corporate/cities/rio-de-janeiro-e0c29740d96fcf97baba86dea73d4a7d.png";